import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/core/services/auth.service';
import { Login, UserLoginDto, newLoginDto } from 'app/core/utils/auth.utils';
import { generalAnimations } from 'app/shared/animations/animations';
import { displayError, isFormControlError } from 'app/shared/forms/utils/forms.utils';
import { DxTextBoxModule, DxDropDownButtonModule, DxButtonModule } from 'devextreme-angular';
import { environment } from 'environments/environment';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    DxTextBoxModule,
    DxDropDownButtonModule,
    DxButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: generalAnimations,
})
export class LoginComponent {
  private subscription = new Subscription();
  isFormControlError = isFormControlError;
  passwordMode = 'password';
  oktaUrl = '';
  loginInvalid = false;
  loginFormGroup: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(
    private ref: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    this.subscription.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.oktaUrl = this.router.url.includes('login-local') ? '' : environment.oktaUrl;
        this.ref.markForCheck();
      })
    );
  }

  onPasswordViewClick(): void {
    this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
  }

  onLoginClick(): void {
    if (this.loginFormGroup.valid) {
      const login = this.loginFormGroup.getRawValue() as Login;
      const loginDto = newLoginDto(login);
      this.subscribeToLogin(loginDto);
    } else {
      displayError(this.translate);
    }
  }

  redirectToOkta(): void {
    window.location.href = this.oktaUrl;
  }

  private subscribeToLogin(loginDto: UserLoginDto): void {
    this.subscription.add(
      this.authService.loginUser(loginDto).subscribe(
        res => {
          if (res) {
            this.loginInvalid = false;
            this.router.navigate(['/dashboard']).then();
            this.ref.markForCheck();
          }
        },
        () => {
          this.loginInvalid = true;
          this.ref.markForCheck();
        }
      )
    );
  }
}
